import type { ComponentType } from '@grafikr/components';
import Drawer from 'utils/components/drawer';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const Component: ComponentType = (node, { emitter }) => {
  const drawer = new Drawer(node, { overlay: false });
  const toggles = document.querySelectorAll(`[data-load="${node.dataset.loadTarget}"]`);

  drawer.on('open', () => disablePageScroll());
  drawer.on('close', () => enablePageScroll());

  emitter.on('club-signup:open', () => drawer.open());

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', drawer.toggle);
  });
};

export default Component;
